export default {
  switchToMeaning: 'Prepnúť na význam',
};
